import { useState } from 'react'
import { useUserSession } from 'features/session/context'

import {
  Stack,
  StackProps,
  Box,
  Fade,
  IconButton
} from '@mui/material'

import { EditIcon } from 'shared/icons'
import { ImageFileInput } from 'components/controls/imageFileInput'
import { ErrorBlock } from 'components/controls/errorInfo'
import { MarkdownPreview } from 'components/controls/markDownPreview'

import { SearchResult, useGetSearchBunner, useSetSearchBunner } from 'interface/search'

import { EditSearchsDescriptionDialog } from 'features/search/dialog/editSearchsDescriptionDialog'
import { ValueSpan } from 'components/controls/valueSpan'
import { dateTimeStampFormat } from 'shared/util'

type SearchSideAreaProps = {
	search: SearchResult,
	onChangeSearch: (result: SearchResult) => void
} & StackProps
export const SearchSideArea = ({
	search,
	onChangeSearch,
	...others
}: SearchSideAreaProps) => {
  const { isGeneral } = useUserSession()

	const [modal, setModal] = useState<'editDescription' | null>(null)
  const [showDescriptionEditIcon, setShowDescriptionEditIcon] = useState<boolean>(false)
  const bunnerState = useGetSearchBunner(search.searchId, { updateTime: search.updateTime })
  const [bunnerPostState, setBunner] = useSetSearchBunner(search.searchId)

	return (
		<Stack {...others} spacing={1} padding={1}>
			<Box position="relative">
	      <ImageFileInput
					edittable={isGeneral}
					state={{ ...bunnerState, loading: bunnerState.loading || bunnerPostState.posting }}
					onChangeFile={setBunner}
					alt={search.title}
					overflow='hidden'
					width="100%"
					height="12rem"
					borderRadius={1}
					boxSizing="border-box"
					position='relative'
				/>
				<Stack
					position="absolute"
					bottom={0} left={0} boxSizing="border-box"
					margin={1} paddingX={2} paddingY={1} spacing={0.5}
					borderRadius={1}
					sx={{
						background: "rgba(255, 255, 255, 0.5)",
						pointerEvents: "none"
					}}
					direction="column"
				>
					<ValueSpan prefix="登録" variant="body2" text={dateTimeStampFormat(search.createTime)} align="left"/>
					<ValueSpan prefix="更新" variant="body2" text={dateTimeStampFormat(search.updateTime)} align="left"/>
				</Stack>
			</Box>
      <ErrorBlock error={bunnerPostState.error}/>

			<Box
				flexGrow={1}
        minHeight="5rem"
				overflow="auto"
				width="100%"
				position="relative"
				boxSizing="border-box"
				border={1}
				borderColor="divider"
				borderRadius={1}
				onMouseEnter={() => setShowDescriptionEditIcon(true)}
				onMouseLeave={() => setShowDescriptionEditIcon(false)}
			>
        { isGeneral && (
          <Fade in={showDescriptionEditIcon} timeout={500}>
            <Box
              position="absolute"
              top={0}
              right={0}
              margin={1}
              zIndex={10}
              onClick={() => setModal('editDescription')}
            >
              <IconButton>
                <EditIcon />
              </IconButton>
            </Box>
          </Fade>
        )}
        <MarkdownPreview value={search.description} emptyText='メモ'/>
		  </Box>

			{modal === 'editDescription' ? (
				<EditSearchsDescriptionDialog
					search={search}
					onSubmit={(result) => {
						setModal(null)
						onChangeSearch(result)
					}}
					onClose={() => setModal(null)}
				/>
			) : (
				<></>
			)}
		</Stack>
	)
}